module.exports = __webpack_public_path__ + "static/media/Memory in Pixel LCD.05977c3e.png";